export default "/fr/_next/static/assets/images/qrcode-blick-app-fr.ddb5e444b9f14be05ba53658d5fd2b22.svg";